import React from 'react'
import { CRow, CCol, CCardBody, CCardText, CNavGroup, CNavLink, CNavItem } from '@coreui/react'
import { useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'

const AppNavBuscador = ({ id, items, base }) => {
  const location = useLocation()
  const _navLink = (name, badge) => {
    return (
      <CCol>
        <CCardBody className="h-100 w-100 margin-padding-0">
          <CCardText className="hijo">
            <span>&nbsp;</span>
            {name && name}
            <span>&nbsp;</span>
            {badge && <span>({badge.text})</span>}
          </CCardText>
        </CCardBody>
      </CCol>
    )
  }

  const navItem = (item, index) => {
    const { name, badge, ...rest } = item
    const Component = CNavItem
    return (
      <Component
        {...(!rest.nodos && {
          component: CNavLink,
        })}
        href={rest.target === '_blank' ? rest.to : base + rest.to}
        key={'ni_' + id + '_' + index}
        target={rest.target}
        className={
          location.pathname === (base + rest.to).substring(0, (base + rest.to).indexOf('?'))
            ? 'li-buscador-celu negrita b-gris'
            : 'li-buscador-celu'
        }
      >
        {_navLink(name, badge)}
      </Component>
    )
  }
  const navGroup = (item, index) => {
    const { name, to, ...rest } = item
    const Component = CNavGroup
    return (
      <Component
        idx={String(index)}
        key={'ng_' + index + '_' + id}
        toggler={_navLink(name)}
        visible={location.pathname.startsWith(to)}
        className={rest.classname}
      >
        {item.nodos?.map((item, index) =>
          item.nodos?.length > 0 ? navGroup(item, index) : navItem(item, index),
        )}
      </Component>
    )
  }

  return (
    <>
      <React.Fragment>
        <CRow
          id={id}
          xs={{ cols: 2, gutter: 1 }}
          sm={{ cols: 2, gutter: 1 }}
          md={{ cols: 2, gutter: 1 }}
          className="h-100 w-100 margin-padding-0"
        >
          {items &&
            items?.map((item, index) =>
              item.nodos ? navGroup(item, index) : navItem(item, index),
            )}
        </CRow>
      </React.Fragment>
    </>
  )
}

AppNavBuscador.propTypes = {
  id: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  base: PropTypes.string.isRequired,
}

export default AppNavBuscador
